(function () {
  'use strict';

  function initHero(hero) {
    if (!hero || hero.dataset.noveraHeroReady === 'true') return;
    hero.dataset.noveraHeroReady = 'true';

    if (!hero.classList.contains('novera-hero--reveal')) {
      hero.classList.add('is-visible');
      return;
    }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      hero.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        hero.classList.add('is-visible');
        observer.unobserve(hero);
      });
    }, {
      threshold: 0.12
    });

    observer.observe(hero);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-novera-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
